export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '澳门新葡京app是否官方正版？',
    answer: '是的，澳门新葡京app由澳门新葡京娱乐平台官方开发运营，获得澳门特别行政区政府合法授权。我们建议您仅从官方网站下载app，确保使用正版安全的应用。所有通过官方渠道下载的app均经过严格安全检测，保障您的账户和资金安全。',
  },
  {
    id: 'faq-2',
    question: '如何下载澳门新葡京app？',
    answer: '您可以通过本网站首页的"立即下载"按钮获取app。安卓用户可直接下载APK安装包进行安装，苹果用户可通过官方提供的iOS版本进行安装。下载前请确保设备已开启"允许安装未知来源应用"的权限设置。',
  },
  {
    id: 'faq-3',
    question: '澳门新葡京平台是否安全可靠？',
    answer: '澳门新葡京平台采用银行级SSL加密技术保障数据传输安全，所有游戏均使用经国际认证的随机数生成器确保公平性。平台还设有专业安全团队24小时监控，并定期接受第三方独立审计，全方位保障玩家权益。',
  },
  {
    id: 'faq-4',
    question: '新用户注册需要哪些条件？',
    answer: '新用户注册需年满21周岁，提供有效的手机号码和基本信息即可完成注册。为保障账户安全，建议完成实名认证以享受完整的平台服务。注册过程完全免费，新用户还可领取专属新人礼包。',
  },
  {
    id: 'faq-5',
    question: '平台支持哪些游戏类型？',
    answer: '澳门新葡京平台提供丰富多样的游戏类型，包括老虎机、百家乐、轮盘、骰宝等桌面游戏，德州扑克等扑克竞技，真人视讯直播游戏，以及体育赛事投注等多个品类，共计超过800款精品游戏供您选择。',
  },
  {
    id: 'faq-6',
    question: '充值提现是否方便快捷？',
    answer: '平台支持多种主流支付方式，充值实时到账，提现申请审核通过后一般1-2小时内到账。我们建立了高效的出入金处理系统，确保您的资金流转顺畅无阻。会员等级越高，提现额度越大，处理速度越快。',
  },
  {
    id: 'faq-7',
    question: '遇到问题如何联系客服？',
    answer: '我们提供7×24小时全天候客户服务。您可以通过app内的在线客服功能实时咨询，或拨打客服热线+853 2888 8888。铂金及以上等级会员还享有专属VIP客服经理的一对一服务。',
  },
];